
import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "Como a M4 Digital pode acelerar minhas vendas?",
      answer: "Utilizamos uma combinação de tráfego pago qualificado, automações inteligentes, CRM otimizado e agentes de IA para criar um funil de vendas altamente eficiente. Nossa metodologia já aumentou as vendas de mais de 1.200 empresas em até 300%."
    },
    {
      question: "Quanto tempo leva para ver os primeiros resultados?",
      answer: "Os primeiros resultados começam a aparecer entre 15 a 30 dias após a implementação. No primeiro mês, nossos clientes já observam aumento na geração de leads qualificados e melhoria nas taxas de conversão."
    },
    {
      question: "Vocês trabalham com que tipo de empresa?",
      answer: "Atendemos empresas B2B e B2C de diversos segmentos, desde startups até grandes corporações. Nosso foco são negócios que faturam a partir de R$ 50.000/mês e buscam escalar suas operações comerciais com tecnologia e automação."
    },
    {
      question: "Como funciona a implementação da IA nas vendas?",
      answer: "Implementamos agentes de IA que qualificam leads, respondem dúvidas frequentes, agendam reuniões e nutrem prospects automaticamente. Isso libera sua equipe para focar no fechamento de vendas de alto valor."
    },
    {
      question: "Qual é o investimento necessário?",
      answer: "Para Gestão de Tráfego Pago, nossos planos começam a partir de R$ 1.500/mês. Os demais serviços como CRM, Automação, Agentes de IA e WhatsApp API são valores por projeto, definidos conforme a complexidade e necessidades específicas. No diagnóstico gratuito, apresentamos uma proposta personalizada com ROI projetado."
    },
    {
      question: "Vocês oferecem suporte durante a implementação?",
      answer: "Sim! Oferecemos suporte completo com consultores especializados, treinamento da equipe, acompanhamento semanal e suporte técnico. Você terá um gerente de sucesso dedicado ao seu projeto."
    },
    {
      question: "Como posso medir os resultados?",
      answer: "Fornecemos dashboards em tempo real com métricas como: custo por lead, taxa de conversão, ROI das campanhas, lifetime value dos clientes e muito mais. Relatórios mensais detalhados também são inclusos."
    },
    {
      question: "Trabalham com WhatsApp Business?",
      answer: "Sim! Somos especialistas em WhatsApp API e automações. Criamos chatbots inteligentes, campanhas de reativação, atendimento automatizado e integrações completas com seu CRM."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="container px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
              Perguntas Frequentes
            </h2>
            <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
              Tire suas dúvidas sobre como acelerar suas vendas com a M4 Digital
            </p>
          </div>

          {/* FAQ Items */}
          <div className="space-y-3 lg:space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 lg:px-8 py-4 lg:py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                >
                  <h3 className="text-base lg:text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className={`w-6 h-6 lg:w-8 lg:h-8 flex items-center justify-center rounded-full bg-gradient-to-r from-orange-500 to-red-500 text-white transition-transform duration-300 flex-shrink-0 ${openFAQ === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-lg lg:text-xl"></i>
                  </div>
                </button>
                
                <div className={`overflow-hidden transition-all duration-300 ${openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="px-6 lg:px-8 pb-4 lg:pb-6">
                    <div className="w-full h-px bg-gradient-to-r from-orange-500 to-red-500 mb-3 lg:mb-4"></div>
                    <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}